/**
 * Shared service constants used across the application
 * This ensures consistency between landing header, signup, and program browsing
 */

export const AVAILABLE_SERVICES = [
  'Yoga Trainer',
  'Dietitian',
  'Gym Instructor',
  'Zumba Instructor',
  'Reiki Healer',
  'Astrologer',
  'Numerologer',
  'Ayurveda Practitioner',
  'Others',
];

/**
 * Map service names to display-friendly program category names
 */
export const SERVICE_TO_CATEGORY_NAME = {
  'Yoga Trainer': 'Yoga Programs',
  'Dietitian': 'Dietitian Programs',
  'Gym Instructor': 'Gym Programs',
  'Zumba Instructor': 'Zumba Programs',
  'Reiki Healer': 'Reiki Programs',
  'Astrologer': 'Astrology Programs',
  'Numerologer': 'Numerology Programs',
  'Ayurveda Practitioner': 'Ayurveda Programs',
  'Others': 'Other Programs',
};

/**
 * Map service names to category descriptions
 */
export const SERVICE_TO_CATEGORY_DESCRIPTION = {
  'Yoga Trainer': 'Transform your mind and body with our yoga programs',
  'Dietitian': 'Get personalized nutrition guidance and meal plans',
  'Gym Instructor': 'Build strength and fitness with expert guidance',
  'Zumba Instructor': 'Dance your way to fitness with fun Zumba sessions',
  'Reiki Healer': 'Experience energy healing and wellness practices',
  'Astrologer': 'Discover insights through personalized astrology readings',
  'Numerologer': 'Explore your life path through numerology',
  'Ayurveda Practitioner': 'Embrace holistic wellness with Ayurvedic practices',
  'Others': 'Explore various specialized training programs',
};

